import React from 'react';
import Grid from '@mui/material/Grid2';
import Column from './Column';

export default function Row({ row }) {
    function parseSpacingProps(row) {
        const defaultSpacing = { lg: 0, md: 0, sm: 0, xs: 0 };
        const spacing = row?.props?.spacing ?? defaultSpacing;
        // Create a new object with parsed integers
        const parsedSpacing = Object.fromEntries(
            Object.entries(spacing).map(([key, value]) => [key, parseInt(value, 10)])
        );
        return parsedSpacing;
    }

    return (
          <Grid 
                container 
                sx={[row?.style ?? {}, {position: 'relative'}]}
                spacing={parseSpacingProps(row)}
                direction={row?.props?.direction ?? {xl: 'row', lg: 'row', md: 'row', xs: 'row'}} 
                alignItems={row?.props?.alignItems ?? {xl: 'unset', lg: 'unset', md: 'unset', xs: 'unset'}} 
                justifyContent={row?.props?.justifyContent ?? {xl: 'unset', lg: 'unset', md: 'unset', xs: 'unset'}} 
            >
                    {row.columns.map((column) => (
                        <Column id={column.id} key={column.id} column={column} />
                    ))}
            </Grid>
    )
}